import React from "react";

import { useAuth } from "../../contexts/AdminContext";
import { CopyToClipboard } from "react-copy-to-clipboard";
import copyWhite from "../../img/copy-white.png";
import greenBall from "../../img/ball-green.png";
import greyBall from "../../img/ball-grey.png";
import orangeBall from "../../img/ball-orange.png";
import * as FirestoreService from "../../utils/firebase";
import { Link, useLocation } from "react-router-dom";
import "./Match.css";
function Match(props) {
  let { isAdmin } = useAuth();

  let sets = [1, 2, 3];

  const getTime = (time) => {
    let hours = Math.trunc(time / 60);
    let minutes = time % 60;
    if (hours < 10) hours = `0${hours}`;
    if (minutes < 10) minutes = `0${minutes}`;

    return hours + ":" + minutes;
  };

  return (
    <div className="match-card">
      <table className="match-card-table">
        <tbody>
          <tr>
            <td className="match-card-table-name">{props.match.player1}</td>
            {props.match.status === 2 ? (
              <td className="match-card-table-cell small-score">
                {props.match[`scoreplayer1`]}
              </td>
            ) : undefined}

            {sets.map((set) => (
              <td className="match-card-table-cell">
                {props.match[`set${set}player1`]}
              </td>
            ))}
          </tr>
          <tr>
            <td className="match-card-table-name">{props.match.player2}</td>
            {props.match.status === 2 ? (
              <td className="match-card-table-cell small-score">
                {props.match[`scoreplayer2`]}
              </td>
            ) : undefined}
            {sets.map((set) => (
              <td className="match-card-table-cell">
                {props.match[`set${set}player2`]}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
      <div className="match-card-mgmt">
        <div>
          {isAdmin ? (
            <div>
              <span className="match-card-edit">{props.match.code}</span>
              <CopyToClipboard text={props.match.code}>
                <button className="copy-code-btn">
                  <img className="copy-code-img" src={copyWhite} alt="" />
                </button>
              </CopyToClipboard>
            </div>
          ) : undefined}

          <span className="match-card-edit">
            {props.match.status == "2"
              ? "W trakcie"
              : props.match.status == "1"
              ? "Nierozpoczęty"
              : "Zakończony"}
          </span>

          <span className="match-card-edit">
            {props.match.time ? getTime(props.match.time) : "--:--"}
          </span>
          <img
            src={
              props.match.status == "2"
                ? greenBall
                : props.match.status == "0"
                ? orangeBall
                : greyBall
            }
            alt={props.match.status}
            className={
              props.match.status == "2" ? "statusIcon live" : "statusIcon"
            }
          />
        </div>
        {isAdmin ? (
          <div>
            <button className="match-card-edit">
              <Link to={`/admin/match/${props.match.code}`}>Edytuj</Link>
            </button>
            <button
              className="match-card-edit"
              onClick={() => FirestoreService.deleteMatch(props.match.id)}
            >
              Usuń
            </button>
          </div>
        ) : undefined}
      </div>
    </div>
  );
}

export default Match;
